/** 与后端 PlatformAdminGovernance.ACCOUNT 一致 */
export const PLATFORM_ADMIN_ACCOUNT = 'admin'

export function isPlatformAdminAccount (account) {
  return String(account || '').trim().toLowerCase() === PLATFORM_ADMIN_ACCOUNT
}

export function isPlatformAdminFromStore (store) {
  if (!store || !store.state || !store.state.user) {
    return false
  }
  const name = store.state.user.partnerName || localStorage.getItem('partnerName')
  return isPlatformAdminAccount(name)
}



// WEBPACK FOOTER //
// ./src/utils/platformAdmin.js